export default "__VITE_ASSET__Cppz0Dl2__"